module.exports = __webpack_public_path__ + "static/media/matej_serbec.37fe23ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/team/matej_serbec.jpg
// module id = 215
// module chunks = 0